import React from 'react'
import { Collapse } from 'react-bootstrap'

export const ItemGroup = props => {
  return (
    <div className="mt-5">
      <div className="d-flex justify-content-between">
        <React.Fragment>
          <div className="d-flex align-items-center">
            <input
              type="checkbox"
              disabled={props.linksPosting || props.linksPosted}
              checked={props.selected}
              onChange={() =>
                props.handleCheckChange(
                  props.itemId,
                  props.allGroups,
                  props.selectedArray,
                  props.selected,
                  props.dispatch
                )
              }
            />
            <span className="ml-2 font-weight-bold">{props.itemTitle}</span>
          </div>
        </React.Fragment>
        <a
          onClick={() =>
            props.handleCollapseChange(
              props.itemId,
              props.expandedArray,
              props.expanded,
              props.dispatch
            )
          }
        >
          {props.expanded ? (
            <div className="fa-light fa-chevron-up" />
          ) : (
            <div className="fa-light fa-chevron-down" />
          )}
        </a>
      </div>
      <hr className="mt-2 mb-3" />
      <Collapse in={props.expanded}>
        <div>{props.childCompsFunc(...props.childData)}</div>
      </Collapse>
    </div>
  )
}
